import type { ImageProps } from 'next/image'
import Image from 'next/image'
import { forwardRef, type RefAttributes } from 'react'

import { useSmartCropFeaturedImageLoader } from '../../hooks/image/useSmartCropFeaturedImageLoader/useSmartCropFeaturedImageLoader'
import { useSmartCropImageLoader } from '../../hooks/image/useSmartCropImageLoader/useSmartCropImageLoader'

interface SmartCropImageProps
	extends ImageProps,
		RefAttributes<HTMLImageElement> {
	readonly showAsFeatured?: boolean
}

const SmartCropImage = (
	{
		src,
		sizes,
		priority,
		alt,
		showAsFeatured,
		draggable = true,
		onClick,
		onLoad,
	}: SmartCropImageProps,
	ref: React.Ref<HTMLImageElement>
) => {
	const loaderWithoutFeatured = useSmartCropImageLoader()
	const loaderFeatured = useSmartCropFeaturedImageLoader()
	const loader = showAsFeatured ? loaderFeatured : loaderWithoutFeatured

	return (
		<Image
			alt={alt}
			src={src}
			sizes={sizes}
			priority={priority}
			ref={ref}
			fill
			loader={loader}
			draggable={draggable}
			onClick={onClick}
			onLoad={onLoad}
		/>
	)
}

export default forwardRef(SmartCropImage)
